<template>
<section class="main">
  <div class="content_page_title">
    <h1>Liste des incidents sur les émetteurs TNT</h1>
  </div>
  <div class="main_content">
    <fiche-incident ref="ficheIncident"></fiche-incident>
    <div class="list">
      <h2>Incidents en cours</h2>
      <table>
        <thead>
          <tr>
            <th>Nom de l'émetteur</th>
            <th> Distance <span class="icon_info little grey" title="La distance est..."></span>
            </th>
            <th>Détails</th>
          </tr>
        </thead>
        <tbody v-for="(incident, index) in incidents" :key="index">
          <tr v-if="(incident.incidentEnCours)">
            <td>{{incident.nomEmetteur}}</td>
            <td>{{incident.distance}} km</td>
            <td>
              <button class="icon_info big info_blue" title="Voir le détail" @click="openIncident(incident)"></button>
            </td>
          </tr>
        </tbody>
      </table>
      <h2>Incidents résolus la semaine dernière</h2>
      <table>
        <thead>
          <tr>
            <th>Nom de l'émetteur</th>
            <th> Distance <span class="icon_info little grey" title="La distance est..."></span>
            </th>
            <th>Détails</th>
          </tr>
        </thead>
        <tbody v-for="(incident, index) in incidents" :key="index">
          <tr v-if="!(incident.incidentEnCours)">
            <td>{{incident.nomEmetteur}}</td>
            <td>{{incident.distance}} km</td>
            <td>
              <button class="icon_info big info_blue" title="Voir le détail" @click="openIncident(incident)"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import storeJs from 'store'
import FicheIncident from './FicheIncident.vue'
export default {
  name: 'Incident',
  components: {
    FicheIncident
  },
  data() {
    return {
      incidents: []
    }
  },
  mounted() {
    document.body.classList.add('hamburger_menu');
    this.$store.state.menu.active = false;
    var lon = storeJs.get('prtv:lon')
    var lat = storeJs.get('prtv:lat')
    var rayon = this.$store.state.rayonTnt
    axios.get('/incident' + '?lon=' + lon + '&lat=' + lat + '&rayon=' + rayon).then((response) => {
      this.incidents = response.data.data
    }).catch((error) => {
      console.error(error)
    })
  },
  destroyed() {
    this.incidents = []
    document.body.classList.remove('hamburger_menu');
  },
  methods: {
    openIncident(incident) {
      if (incident) {
        this.$refs['ficheIncident'].loadIncident(incident)
      }
    },
    parseDistance(distance) {
      var distance = parseFloat(distance.toString())
      return Math.round(distance * 100) / 100;
    }
  }
}
</script>
<style>
</style>
